import { Grid } from "@material-ui/core";
import { InputOptionMaster } from "App/Component/ui";
import React from "react";

export const PilihFlagProcedure = ({ formData, handleChange }) => {
  return (
    <>
      <Grid item sm={4}>
        <InputOptionMaster
          name='flag_procedure'
          label='FLAG PROSEDUR'
          id='flag_procedure'
          value={formData.flag_procedure}
          onChange={handleChange("flag_procedure")}
          data={[
            {
              value: "",
              label: "Pilih",
            },
            {
              value: 0,
              label: "Prosedur Tidak Berkelanjutan",
            },
            {
              value: 1,
              label: "Prosedur dan Terapi Berkelanjutan",
            },
          ]}
          placeholder=''
        />
      </Grid>
    </>
  );
};
